module.exports = __webpack_public_path__ + "static/the-age-of-napoleon-f71d1c557adbfddc737628d667b522ff.jpg";